import React from 'react';
import { MapPin } from 'lucide-react';
import { fadeIn, shimmer } from './animations';

const AddressSearchResults = ({ results, isLoading, onSelect, isDarkTheme = true }) => {
  if (!results.length && !isLoading) return null;
  
  const baseClasses = isDarkTheme 
    ? "absolute z-10 mt-1 w-full rounded-lg shadow-xl bg-gray-800 border border-gray-700 overflow-hidden"
    : "absolute z-10 mt-1 w-full rounded-lg shadow-xl bg-white border border-gray-200 overflow-hidden";
  
  const loadingBgClasses = isDarkTheme
    ? "bg-purple-900/20"
    : "bg-purple-100";
  
  const textClasses = isDarkTheme
    ? "text-white"
    : "text-gray-900";
  
  const secondaryTextClasses = isDarkTheme
    ? "text-gray-400"
    : "text-gray-500";
  
  const hoverBgClasses = isDarkTheme
    ? "hover:bg-gray-700"
    : "hover:bg-gray-100";
  
  // Handle selection and ensure dropdown closes
  const handleSelect = (result) => {
    onSelect(result);
    // The parent component should clear the results array
  };
  
  return (
    <div
      className={baseClasses}
      style={{ animation: `${fadeIn} 0.2s ease-out` }}
    >
      <ul className="py-1 max-h-60 overflow-auto">
        {isLoading ? (
          // Loading state
          Array(3).fill().map((_, index) => (
            <li
              key={`loading-${index}`}
              className="px-4 py-3 flex items-center"
            >
              <div className={`p-2 rounded-full ${loadingBgClasses} mr-3`}>
                <MapPin className="h-4 w-4 text-purple-500" />
              </div>
              <div className="flex-1">
                <div
                  className="h-4 w-3/4 rounded mb-2"
                  style={{
                    animation: `${shimmer} 1.5s infinite linear`,
                    background: isDarkTheme ? 'rgba(139, 92, 246, 0.2)' : 'rgba(139, 92, 246, 0.1)'
                  }}
                ></div>
                <div
                  className="h-3 w-1/2 rounded"
                  style={{
                    animation: `${shimmer} 1.5s infinite linear`,
                    background: isDarkTheme ? 'rgba(139, 92, 246, 0.1)' : 'rgba(139, 92, 246, 0.05)'
                  }}
                ></div>
              </div>
            </li>
          ))
        ) : (
          // Results
          results.map((result) => (
            <li key={result.id || result.placeId} className="px-1">
              <button
                type="button"
                className={`w-full px-3 py-2.5 flex items-center ${textClasses} ${hoverBgClasses} transition-colors rounded-md my-1`}
                onClick={() => handleSelect(result)}
              >
                <div className={`p-1.5 rounded-full ${loadingBgClasses} mr-3 flex-shrink-0`}>
                  <MapPin className="h-4 w-4 text-purple-500" />
                </div>
                <div className="text-left overflow-hidden">
                  <div className="font-medium truncate text-sm">{result.mainText || result.description}</div>
                  <div className={`${secondaryTextClasses} text-xs truncate`}>
                    {result.secondaryText || (result.description && result.description.split(',').slice(1).join(',').trim())}
                  </div>
                </div>
              </button>
            </li>
          ))
        )}
      </ul>
    </div>
  );
};

export default AddressSearchResults;